var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 670,
    height: 848,
    viewBox: "0 0 670 848",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M333.444 85.5315L469.178 26.8411L488.042 70.4706L352.308 129.161L333.444 85.5315ZM395.64 49.7165C388.367 52.8626 381.489 53.2443 374.997 50.8746C368.505 48.505 363.756 43.8456 360.752 36.8921C357.748 29.943 357.606 23.2956 360.322 16.9366C363.042 10.5821 368.034 5.83402 375.307 2.68783C382.58 -0.45836 389.463 -0.839985 395.955 1.52964C402.447 3.9037 407.195 8.56308 410.199 15.5122C413.203 22.4613 413.345 29.1131 410.63 35.4676C407.91 41.8221 402.917 46.5703 395.644 49.7165H395.64ZM441.333 155.396C434.06 158.542 427.182 158.923 420.69 156.554C414.197 154.184 409.449 149.525 406.445 142.571C403.441 135.626 403.299 128.975 406.019 122.62C408.735 116.261 413.732 111.518 421.005 108.371C428.278 105.225 435.156 104.839 441.652 107.213C448.144 109.583 452.892 114.247 455.897 121.191C458.901 128.14 459.043 134.792 456.327 141.147C453.607 147.501 448.615 152.249 441.342 155.396H441.333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M207.841 211.695L227.738 240.677L200.066 257.135L226.722 274.983L205.143 302.788L181.091 281.741L172.403 312.28L139.241 300.592L151.888 271.291L120 272.569L121.008 237.424L152.625 240.286L141.624 210.28L175.327 200.131L182.538 231.611L207.836 211.7L207.841 211.695Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M347.462 345.878L188.816 444.845L136.865 436.168L198.591 342.998L339.857 311.631L347.462 345.878Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M351.018 322.618C303 337.051 245.406 360.458 186.511 399.493C168.355 411.528 151.838 423.891 136.884 436.137C133.782 420.436 134.675 407.361 137.162 396.728C151.402 335.751 232.94 291.611 339.816 282.219C343.548 295.677 347.28 309.135 351.013 322.594L351.018 322.618Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M427.25 279.782C571.402 318.407 734.439 580.66 635.336 742.949C549.913 882.839 307.091 854.358 183.081 799.158C75.838 751.404 -15.7677 643.372 5.11736 605.132C19.8177 578.264 84.7281 587.628 140.869 599.724C140.218 573.585 141.255 543.085 145.748 509.374C151.017 469.8 174.679 435.721 191.502 407.534C204.061 386.49 227.325 323.163 309.356 293.204C319.639 289.44 375.905 269.663 427.224 279.782L427.25 279.782Z",
    fill: "#F4B7EA",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M575.626 392.194C565.342 329.601 512.065 231.789 387.526 231.788C262.987 231.787 215.051 328.711 199.736 392.194C199.736 392.194 285.499 360.684 389.375 360.684C493.252 360.684 575.626 392.194 575.626 392.194Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M390.182 287.392C351.174 287.392 340.6 317.487 340.6 337.555C340.6 337.555 369.011 333.559 389.209 333.559C409.407 333.559 437.818 337.555 437.818 337.555C437.818 319.048 429.191 287.392 390.182 287.392Z",
    fill: "#F4B7EA",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M447.548 334.041C394.81 324.099 339.306 334.337 318.146 341.365C318.146 345.094 317.258 358.456 317.258 365.115C369.196 357.789 416.104 359.861 447.548 363.338C457.223 364.328 466.839 360.897 466.839 350.909C466.839 340.92 457.293 335.878 447.548 334.041Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M315.8 552.51L315.774 552.509C286.1 552.226 262.275 527.942 262.558 498.268L262.651 488.537C262.934 458.863 287.219 435.038 316.892 435.321L316.918 435.321C346.591 435.604 370.417 459.889 370.134 489.562L370.041 499.294C369.758 528.967 345.473 552.793 315.8 552.51Z",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M316.206 528.221C302.841 528.094 292.154 512.591 292.335 493.596C292.516 474.6 303.498 459.305 316.863 459.432C330.228 459.56 340.916 475.062 340.734 494.058C340.553 513.053 329.571 528.349 316.206 528.221Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M309.244 455.036L318.201 482.31L286.688 476.834L309.244 455.036Z",
    fill: "#FFFBF7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M454.302 552.51L454.276 552.509C424.602 552.226 400.777 527.942 401.06 498.268L401.153 488.537C401.436 458.863 425.721 435.038 455.394 435.321L455.42 435.321C485.093 435.604 508.919 459.889 508.636 489.562L508.543 499.294C508.26 528.967 483.975 552.793 454.302 552.51Z",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M454.708 528.221C441.343 528.094 430.656 512.591 430.837 493.596C431.018 474.6 442 459.305 455.365 459.432C468.73 459.56 479.418 475.062 479.236 494.058C479.055 513.053 468.073 528.349 454.708 528.221Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M447.746 455.036L456.703 482.31L425.19 476.834L447.746 455.036Z",
    fill: "#FFFBF7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.092 398.532L318.396 391.609C326.591 390.268 334.321 395.824 335.662 404.019L336.24 407.55C337.581 415.745 332.025 423.476 323.83 424.817L281.526 431.739C273.332 433.08 265.601 427.524 264.26 419.329L263.682 415.798C262.341 407.603 267.897 399.873 276.092 398.532Z",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M495.228 398.532L452.924 391.609C444.729 390.268 436.999 395.824 435.658 404.019L435.08 407.55C433.739 415.745 439.295 423.476 447.49 424.817L489.793 431.739C497.988 433.08 505.719 427.524 507.06 419.329L507.638 415.798C508.979 407.603 503.422 399.873 495.228 398.532Z",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M383.594 587.294C356.012 587.294 347.907 567.133 348.209 557.695H420.793C420.793 565.417 418.072 587.294 383.594 587.294Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M384.501 523.592C350.387 523.592 336.414 543.753 333.692 553.834L385.409 566.06L437.125 553.834C433.798 543.753 418.616 523.592 384.501 523.592Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonCover);
export default __webpack_public_path__ + "static/media/lesson-cover.995cb55d8243bf1719138e88ec16c713.svg";
export { ForwardRef as ReactComponent };